import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logError } from '@log';
import {
  addSelectedItems, clearSelectedItems, deleteSelectedItems, setPackageList,
} from '@store';
import { useBehaviorData } from '@hooks';
import { useState } from 'react';
import { getPackage } from '@api';
import {
  ErrorCodeToSpecialText, ErrorCode, ClaimType, PLATFORM_NAME, NEED_TO_ADD_TRACKING_NUMBER,
} from '@constants';

export const usePackageCheckbox = () => {
  const {
    fulfilledItems,
    unFulfilledItems, orderName, type, selectedItems, policyId, currentPolicy = {}, merchantId,
  } = useSelector((state) => state.claim);
  const { platform, specialPlatform } = useSelector((state) => state.policy);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const setReportData = useBehaviorData();
  const [open, setOpen] = useState(false);
  const [fulfillmentInfo, setFulfillmentInfo] = useState({});
  const [willChecked, setWillChecked] = useState({
    willCheckedValue: '',
    packageIndex: 0,
    lineIndex: 0,
    willCheckedItem: {},
  });

  const isContinueBtnDisable = selectedItems.length === 0;
  const isNeedToAddTracking = NEED_TO_ADD_TRACKING_NUMBER.includes(specialPlatform);

  const onClickContinue = () => {
    if (!selectedItems.length) {
      logError(new Error(`choose ${type}, onClickContinue error`));
      return;
    }
    setReportData({ chooseItemsTime: `${Date.now()}`, issueType: type });

    navigate('../upload');
  };

  // const handleChange = (event) => {
  //   const { checked, value } = event.target || {};
  //   if (!checked) {
  //     dispatch(deleteSelectedItems(value));
  //   } else {
  //     dispatch(addSelectedItems(value));
  //   }
  // };

  const handleChange = (event, packageIndex, lineIndex, item) => {
    const { checked, value } = event.target || {};
    if (!checked) {
      dispatch(deleteSelectedItems(value));
    } else if ((!item.trackingNumber && isNeedToAddTracking)) {
      setOpen(true);
      setFulfillmentInfo({ fulfillmentId: item.fulfillmentId, lineItemId: item.lineItemId });
      setWillChecked({
        willCheckedValue: value, packageIndex, lineIndex, willCheckedItem: item,
      });
    } else {
      dispatch(addSelectedItems(value));
    }
  };

  const handleShippingClick = (fulfillmentId, isUnfulfilled) => {
    setOpen(true);
    setFulfillmentInfo({ fulfillmentId, isUnfulfilled });
  };
  const handleOK = async () => {
    setOpen(false);
    const resp = await getPackage({ policyId, issueType: type });
    const { code, data } = resp;
    if (code === 0) {
      dispatch(setPackageList(data));
      const currentItem = data.fulfilledItems.find((ful) => ful.fulfillmentId === fulfillmentInfo.fulfillmentId)?.items?.find((item) => item.lineItemId === fulfillmentInfo.lineItemId);
      if (!fulfillmentInfo.isUnfulfilled && currentItem?.isInEffectivePeriod) {
        dispatch(addSelectedItems(willChecked.willCheckedValue));
      }
    } else if (ErrorCodeToSpecialText.includes(code)) {
      navigate('../error', { state: { code, type } });
    } else {
      navigate('../error', { state: { code: ErrorCode.Wrong } });
    }
  };

  const clearItems = () => {
    dispatch(clearSelectedItems());
    // navigate(-1);
  };

  const getTipsText = () => {
    const { liabilitiesArr } = currentPolicy;
    const windowTime = ['20240713200304665023'].includes(merchantId) ? 14 : 7;
    // garmentory 走的老系统，接口没有返回liabilities
    if (type === ClaimType.Loss && (liabilitiesArr.includes(ClaimType.Theft) || platform === PLATFORM_NAME.GARMENTORY)) {
      return "You can't report loss for a delivered package. If you haven't received it, you may report an issue of theft.";
    }
    return {
      [ClaimType.Damage]: `An issue of damage must be reported within ${windowTime} days upon delivery. You are already past the date.`,
      [ClaimType.Loss]: 'This package is not yet eligible to file a shipping loss claim.',
    }[type];
  };
  return {
    fulfilledItems,
    unFulfilledItems,
    orderName,
    type,
    isContinueBtnDisable,
    selectedItems,
    platform,
    specialPlatform,
    open,
    willChecked,
    fulfillmentInfo,
    handleShippingClick,
    currentPolicy,
    getTipsText,
    onClickContinue,
    handleChange,
    clearItems,
    handleOK,
    handleClose: () => setOpen(false),
  };
};
